type DebugValues = string | number | boolean | object;

export interface DebugProps {
  value?: DebugValues | Array<DebugValues>;
}

export function Debug({ value }: DebugProps) {
  return <pre>{JSON.stringify(value, null, 4)}</pre>;
}
